import { FC } from "react";
import { DateTime } from "luxon";
import classNames from "classnames";

interface TimeMarkerTextProps {
  readonly first: boolean;
  readonly last: boolean;
  readonly dateTime: DateTime;
}

export const TimeMarkerText: FC<TimeMarkerTextProps> = ({ first, last, dateTime }) => {
  const emphasized = isEmphasized({ first, last, dateTime: dateTime });

  return (
    <div
      className={classNames(
        "relative top-[-22px] z-10 mr-[-15px] ml-[-15px] h-[15px] w-[30px]",
        "text-center font-default text-[10px] leading-none font-normal",
        "first:left-[13px] last:left-[-4px]",
        {
          "text-content": emphasized,
          "text-subtle": !emphasized,
        },
      )}
    >
      {(first || dateTime.hour === 0) && (
        <span className="mr-[px] text-[12px] font-bold">{dateTime.toFormat("ccc")}</span>
      )}
      <span className="text-[10px] leading-[13px] font-normal">
        {dateTime.hour.toString().padStart(2, "0")}
      </span>
    </div>
  );
};

type isEmphasizedProps = Pick<TimeMarkerTextProps, "first" | "last" | "dateTime">;

function isEmphasized(props: isEmphasizedProps) {
  return props.first || props.dateTime.hour === 0 || props.last;
}
